import { render, staticRenderFns } from "./CreateSettlementKasbon.vue?vue&type=template&id=dd426e10"
import script from "./CreateSettlementKasbon.vue?vue&type=script&lang=js"
export * from "./CreateSettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports